module.exports = __webpack_public_path__ + "img/e-class-sport-sedan.69ceb44d.jpg";